/**
 * @generated SignedSource<<8fa1595308bd202841cb3d3319c7bdd5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type projectNotificationsConfig_personalSettingsNotificationsConfigTable_projects$data = {
  readonly " $fragmentSpreads": FragmentRefs<"projectNotificationsConfig_personalSettingsNotificationsConfigTable_ProjectNotificationsConfigInner_projects" | "projectNotificationsConfig_personalSettingsNotificationsConfigTable_ProjectNotificationsConfigInner_projectsPaginatedFragment">;
  readonly " $fragmentType": "projectNotificationsConfig_personalSettingsNotificationsConfigTable_projects";
};
export type projectNotificationsConfig_personalSettingsNotificationsConfigTable_projects$key = {
  readonly " $data"?: projectNotificationsConfig_personalSettingsNotificationsConfigTable_projects$data;
  readonly " $fragmentSpreads": FragmentRefs<"projectNotificationsConfig_personalSettingsNotificationsConfigTable_projects">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "projectNotificationsConfig_personalSettingsNotificationsConfigTable_projects",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "projectNotificationsConfig_personalSettingsNotificationsConfigTable_ProjectNotificationsConfigInner_projectsPaginatedFragment"
    },
    {
      "kind": "FragmentSpread",
      "name": "projectNotificationsConfig_personalSettingsNotificationsConfigTable_ProjectNotificationsConfigInner_projects"
    }
  ],
  "type": "Query"
};

(node as any).hash = "de9361a54574487f8c76041f7fbf96eb";

export default node;
